module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-description-84078fff973537a0443dbc553c1a4ad8.png";